import { HyperpayConfigurationsPermissions } from "./payment-management.payment-configurations.hyperpay.permissions";
import { PaymentConfigurationsPermissions } from "./payment-management.payment-configurations.permissions";

export class PaymentManagementPermissions {
  static PaymentConfigurations = PaymentConfigurationsPermissions?.Permissions;
  static HyperpayConfigurations = HyperpayConfigurationsPermissions?.Permissions;
}

export function getPaymentManagementModuleName() {
  return 'PaymentManagement';
}